var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9 6.75C9.58 6.03 10 5.07 10 4c0-2.21-1.79-4-4-4S2 1.79 2 4c0 1.07.42 2.03 1.1 2.75C1.25 7.77 0 9.74 0 12v3c0 .55.45 1 1 1h10c.55 0 1-.45 1-1v-3c0-2.26-1.25-4.23-3.1-5.25zM4 4c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm6 10H2v-2c0-2.21 1.79-4 4-4s4 1.79 4 4v2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.42bd33bba7daa6f77022d85ce6363dea.svg";
export { ForwardRef as ReactComponent };